





























































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import DefaultWorkflowJob from '@/components/workflow/DefaultWorkflowJob.vue';
import {
  JobTabStateModel,
  AutomotiveWorkflowJobModel,
  WorkflowJobTabsToHideModel,
  TabStateModel,
  FieldUpdateModel,
  WorkflowJobButtonModel,
  ManufacturerTabDataSourceUpdateModel,
  WorkflowStandardProcessingAction,
  WorkflowJobTabModel,
  DocumentViewerConstants,
  NotificationConstants,
  EditReferencesButtonTooltipModel,
  DocumentSearchModel
} from '@/types';
import { AutomotiveWorkflowJobService } from '@/services/automotive/AutomotiveWorkflowJobService';
import { ManufacturerTabService } from '@/services/automotive/ManufacturerTabService';
import { EventBus } from '@/classes/EventBus';
import { AutomotiveHelper, AutomotiveWorkflowJob, ObjectHelper } from '@/mixins';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import store from '@/store';

export default Vue.extend({
  name: 'AutomotiveWorkflowJob',
  mixins: [DefaultWorkflowJob, AutomotiveHelper, AutomotiveWorkflowJob, ObjectHelper],
  data() {
    return {
      leftPaneSize: 0,
      rightPaneSize: 0,
      automotiveWorkflowJobModel: {} as AutomotiveWorkflowJobModel,
      automotiveJobIsLoading: true
    };
  },
  methods: {
    ...mapActions('workflowJobStore', ['setJobTabStateHidden', 'setIsLoading']),
    ...mapActions('automotiveWorkflowJobStore', ['unloadAutomotiveWorkflowJob']),
    onDeleteDocument(this: any, documentSearchModel: DocumentSearchModel) {
      this.reloadRelatedDocumentsTab(documentSearchModel);
    }
  },
  computed: {
    ...mapGetters('workflowJobStore', ['isWorkflowJobLocked', 'workflowDataSourceField', 'jobTabState', 'workflowDocumentIsPlaceholder']),
    ...mapGetters('automotiveWorkflowJobStore', ['manufacturerTab']),
    cancelReason(this: any): string | undefined {
      return this.workflowDataSourceField('DealAction', 'DA_CancelReason');
    },
    cancellationValidationMessage(this: any): string | undefined {
      const requireSaleType = this.isNullOrEmpty(this.saleType);

      const requireReason = this.isNullOrEmpty(this.cancelReason);
      if (!requireSaleType && !requireReason) {
        return undefined;
      }
      if (requireSaleType && requireReason) {
        return 'Please select a Sale Type and enter a reason before cancelling.';
      }
      if (requireSaleType) {
        return 'Please select a Sale Type before cancelling.';
      }
      return 'Please enter a reason before cancelling.';
    },
    workflowJobTabsToHideModel(this: any): WorkflowJobTabsToHideModel | undefined {
      const model = this.automotiveWorkflowJobModel as AutomotiveWorkflowJobModel;
      return model.jobTabsToHide.find((x: WorkflowJobTabsToHideModel) => x.saleType === this.saleType);
    },
    getHiddenTabStateModel: () => (tabKey: string, hidden: boolean): TabStateModel => {
      return { key: tabKey, hidden } as TabStateModel;
    },
    isDocumentLoadingOrBeingConverted(this: any) {
      return store.getters['documentViewStore/document'].isBeingConverted || store.getters['documentViewStore/isPageLoading'];
    },
    documentPlaceholder(this: any) {
      return {
        showDocumentPlaceholder: this.workflowDocumentIsPlaceholder,
        documentPlaceholderText: NotificationConstants.WorkflowDocumentPlaceHolderText
      };
    },
    editReferencesTooltip(this: any): EditReferencesButtonTooltipModel | null {
      if (this.isWorkFlowJobDirty) {
        return {
          disabledTooltipMessage: NotificationConstants.CannotEditDocumentLinkedToUpdatedWorkflowJob,
          important: false
        };
      } else {
        return null;
      }
    }
  },
  watch: {
    saleType(this: any) {
      this.hideTabsBasedOnSaleType();
    }
  },
  mounted(this: any) {
    this.initialise();
    this.initializeCanGetNextJob();
  },
  beforeDestroy(this: any) {
    this.unloadAutomotiveWorkflowJob();
  },
  components: {
    LoadingSpinner
  },
  created(this: any) {
    this.documentToolbarOptions = DocumentViewerConstants.DocumentViewerDeleteEnabledToolOptions;
  }
});
